const Errors = require('./errors.js');
const Fields = require('./fields.js');
const Environment = require('../env.js');
const tokenizationURL = Environment.tokenizationURL;

var Tokenization = {
  // Requests a token with the passed in data and executes the callback with a 
  // successful token or an error. 
  // data arg expects properties: `card`, `cvv`, `month`, `year`.
  // merchantGuid identifies the merchant against which the token will be created.
  getToken: function(data, merchantGuid, callback) {
    var self = this;
    const formattedData = self._formatData(data, merchantGuid);
    
    // create AJAX request:
    const isIE9 = window.XDomainRequest ? true : false; 
    let xhr;
    if (isIE9) {
      xhr = new window.XDomainRequest();
    } else {
      xhr = new XMLHttpRequest();
    }
    
    xhr.open('POST', tokenizationURL, true);
    if (!isIE9) {
      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    }
    xhr.timeout = 30000; // milliseconds

    xhr.onload = function(e) {
      var request = e.currentTarget || e.target;
      var result;    

      // successful response
      if (!isIE9 && request.status >= 200 && request.status < 400) {
        result = {
          code: request.status || 200,
          success: true, 
          token: JSON.parse(request.responseText).token,
          last4: formattedData.ccnumber.substr(-4),
          expiryMonth: formattedData.expm,
          expiryYear: formattedData.expy,
        };
      } else if (isIE9 && xhr.responseText && JSON.parse(xhr.responseText).token) {
        result = {
          code: 200,
          success: true, 
          token: JSON.parse(request.responseText).token,
          last4: formattedData.ccnumber.substr(-4),
          expiryMonth: formattedData.expm,
          expiryYear: formattedData.expy,
        };
      // unsuccessful response
      } else {
        result = {
          code: request.status,
          success: false,
          error: Errors.errorDetails('token', Errors.TokenizationFailed),
        };
      }
      callback(result);
    };


    xhr.onerror = function() {
      var result = {
        code: 500,
        success: false,
        error: Errors.errorDetails('token', Errors.TokenizationNoResponse),
      };
      callback(result);
    };

    xhr.ontimeout = function() {
      var result = {
        success: false, 
        code: 504,
        error: Errors.errorDetails('token', Errors.TokenizationNoResponse),
      };
      callback(result);
    };


    xhr.send(JSON.stringify(formattedData));
  },


  // Format the passed in data into the format expected by the 
  // tokenization endpoint. 
  _formatData: function(data, merchantGuid) {
    if (data[Fields.CARD_NUMBER] === null) {
      data[Fields.CARD_NUMBER] = '';
    }

    if (data[Fields.EXPIRY] === null) {
      data[Fields.EXPIRY] = ' / ';
    }

    const monthYear = data[Fields.EXPIRY].split(' / ');
    const month = monthYear[0];
    const year = monthYear[1];

    const number = data[Fields.CARD_NUMBER].replace(/\s/g, '');

    // These property names are required by the tokenization endpoint. 
    let dataObject = {
      ccnumber: number, 
      expm: month,
      expy: '20' + year, // backend uses 4 character years
      merchantguid: merchantGuid,
    };

    if (data.cvv) {
      dataObject.cvn = data.cvv; // endpoint requires 'cvn' field (not 'cvv')
    }

    return dataObject; 
  },
};

module.exports = Tokenization;



// WEBPACK FOOTER //
// ./app/tokenization.js